import { faTimes, faUpload } from '@fortawesome/free-solid-svg-icons'
import RestoreIcon from '@mui/icons-material/Restore'
import { Button as MuiButton } from '@mui/material'

import { Button, DialogWrapper } from '@/components'
import { Modal } from '@/components/Modal/Modal'
import { useAppContext } from '@/hooks'

type RestoreVersionDialogProps = {
	/** Disable the trigger button (e.g. when already on latest version) */
	disabled?: boolean,
	onRestore: () => Promise<void>,
	replacing: boolean,
	/** When set, trigger label becomes "Restore v{version}" (merged version chip + restore) */
	selectedVersion?: number
}

export const RestoreVersionDialog = ({
	onRestore,
	replacing,
	disabled = false,
	selectedVersion,
}: RestoreVersionDialogProps) => {
	const { t } = useAppContext()
	const buttonLabel = selectedVersion != null ? `${t('RESTORE')} v${selectedVersion}` : t('RESTORE')

	return (
		<DialogWrapper
			dialog={(opened, onClose) => (
				<Modal
					open={opened}
					onClose={onClose}
					header={t('RESTORE')}
					footer={() => (
						<>
							<Button
								onClick={async () => {
									await onRestore()
									onClose()
								}}
								icon={faUpload}
								schema="primary"
								className="mr-4"
								disabled={replacing}
							>
								{t('YES')}
							</Button>
							<Button
								onClick={onClose}
								icon={faTimes}
								schema="danger"
								disabled={replacing}
							>
								{t('NO')}
							</Button>
						</>
					)}
				>
					<>{t('MAKE_CURRENTLY_DISPLAYED_VERSION_THE_LATEST_ONE')}</>
				</Modal>
			)}
		>
			{(open) => (
				<MuiButton
					variant="outlined"
					size="small"
					startIcon={<RestoreIcon />}
					onClick={open}
					disabled={replacing || disabled}
					sx={{ textTransform: 'none' }}
				>
					{buttonLabel}
				</MuiButton>
			)}
		</DialogWrapper>
	)
}
